import { Box, Paper, Typography } from '@mui/material';
import { useRecordContext } from 'react-admin';
import { Labeled } from 'react-admin';
import { Chip } from '@mui/material';
import { TagInput } from '@/components/TagInput';

const MAGIC_EDIT_VALID_TAGS = ['@asset.grammar', '@asset.magicEditInstructions'] as const;

export const MagicEditRulesetEditor = ({
  isDirtyRef,
}: {
  isDirtyRef?: React.MutableRefObject<boolean>;
}) => {
  const record = useRecordContext();
  const docId = record?.id ?? record?._id;

  return (
    <>
      {!!docId && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            mb: 2,
          }}
        >
          <Labeled label="ID">
            <Chip label={docId.toString()} />
          </Labeled>
        </Box>
      )}

      <Paper sx={{ p: 3, mb: 3, width: '100%' }} elevation={1}>
        <Typography variant="h6" gutterBottom>
          Magic Edit template
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Use placeholders <code>@asset.grammar</code> (original note) and{' '}
          <code>@asset.magicEditInstructions</code> (user edit instruction). Filled at runtime when the trigger runs.
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TagInput
            source="magicEditTemplate.systemMessage"
            label="System message"
            validTags={MAGIC_EDIT_VALID_TAGS as unknown as string[]}
            markup="{{__id__}}"
            placeholder="System instructions for the Magic Edit revision..."
            fullWidth
          />
          <TagInput
            source="magicEditTemplate.userPromptTemplate"
            label="User prompt template"
            validTags={MAGIC_EDIT_VALID_TAGS as unknown as string[]}
            markup="{{__id__}}"
            placeholder="User prompt with @asset.grammar and @asset.magicEditInstructions..."
            fullWidth
          />
        </Box>
      </Paper>
    </>
  );
};
